export default "__VITE_ASSET__84e00099__"